// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingsPage_container__3DsxR"};